import { FC } from 'react';

import Head from 'next/head';

import { getPlatformStatistic } from '@/api/statistic/get-plarform';
import { PlatformStatisticResult } from '@/api/statistic/types';
import { AboutUsContainer } from '@/components/AboutUsContainer/AboutUsContainer';
import { Footer } from '@/components/Footer/Footer';
import { breadcrumbSchema, graphSchema, organizationSchema } from '@/utils/schema';

type Props = {
	initialStatistic: PlatformStatisticResult;
};

const AboutUs: FC<Props> = ({ initialStatistic }) => {
	return (
		<>
			<Head>
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify(
							graphSchema([
								organizationSchema,
								breadcrumbSchema([
									{ name: 'Главная', url: '/' },
									{ name: 'О компании', url: '/o-kompanii' },
								]),
							]),
						),
					}}
				/>
			</Head>
			<AboutUsContainer initialStatistic={initialStatistic} />
			<Footer />
		</>
	);
};

export default AboutUs;

export const getStaticProps = async () => {
	let initialStatistic: PlatformStatisticResult;

	try {
		initialStatistic = await getPlatformStatistic();
	} catch {
		initialStatistic = null;
	}

	return {
		props: { initialStatistic },
		revalidate: 3600,
	};
};
